// extracted by mini-css-extract-plugin
module.exports =  {"button":"_772e1b1e50--button--wvpRY","dark":"_772e1b1e50--dark--HdtBl"};